import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api, DEFAULT_CATEGORIES } from "@/lib/api";

const DEFAULT_SETTINGS = {
  hero_title: "Aileden Bir",
  hero_highlight: "Habercik.",
  hero_description:
    "Düğün, nişan, kına ve sünnet etkinliklerinizi bize bildirin — yönetici onayının ardından tüm dernek üyeleri takvim üzerinden görsün.",
  hero_kicker: "Üye Etkinlik Bildirim",
  site_name: "ŞAHDER",
  site_subtitle: "Etkinlik Bildirim Sistemi",
  logo_url: null,
  footer_text: "© ŞAHDER — Şahsi Dernek Etkinlik Portalı",
  footer_tagline: "Bir Aradayız, Bir Aradasınız",
};

const SettingsContext = createContext({
  categories: DEFAULT_CATEGORIES,
  categoryMap: {},
  settings: DEFAULT_SETTINGS,
  refresh: () => {},
});

export const SettingsProvider = ({ children }) => {
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  const refresh = useCallback(async () => {
    try {
      const [cRes, sRes] = await Promise.all([
        api.get("/categories"),
        api.get("/settings"),
      ]);
      if (Array.isArray(cRes.data) && cRes.data.length > 0) {
        setCategories(cRes.data);
      }
      if (sRes.data) setSettings({ ...DEFAULT_SETTINGS, ...sRes.data });
    } catch (error) {
      // Keep defaults on error, but log for debugging
      console.error("Ayarlar yüklenemedi:", error);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const categoryMap = useMemo(() => {
    const m = {};
    for (const c of categories) m[c.value] = c;
    return m;
  }, [categories]);

  return (
    <SettingsContext.Provider value={{ categories, categoryMap, settings, refresh }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
